import { useApolloClient } from '@apollo/client';

import { BusinessProfileType } from '@shared/api/fragments.graphql';
import { BusinessProfileTypeFragment } from '@shared/api/graphql/generated';

const useBusinessProfile = () => {
  const client = useApolloClient();

  const getBusinessProfile = (id: string): BusinessProfileTypeFragment | null => {
    const businessProfile = client.readFragment({
      id: `ZvukProfileType:${id}`,
      fragment: BusinessProfileType,
      fragmentName: 'BusinessProfileType',
    });

    return businessProfile;
  };

  return { getBusinessProfile };
};

export default useBusinessProfile;
